import { ExternalLink } from "lucide-react";

/**
 * Current Academy offer.
 *
 * Before September 2, 2026 the AI Build Summit is featured. On and after that
 * date the section automatically falls back to the evergreen Fresh Vision
 * Academy offer so no stale date is ever promoted.
 */
const SUMMIT_EXPIRES_AT = new Date("2026-09-02T00:00:00-04:00");

const AcademyClasses = () => {
  const summitIsCurrent = new Date() < SUMMIT_EXPIRES_AT;

  const content = summitIsCurrent
    ? {
        eyebrow: "Current Academy Offer",
        heading: "The AI Build Summit: The Unfair Advantage",
        body: "Live on Zoom, September 15 and 16, with VIP Build Day September 17.",
        cta: "Explore the AI Build Summit",
        href: "https://freshvisionacademy.org/summit-agents",
      }
    : {
        eyebrow: "Fresh Vision Academy",
        heading: "Build systems you understand and own.",
        body: "Training and implementation for real estate professionals who want working systems instead of another subscription.",
        cta: "Explore Fresh Vision Academy",
        href: "https://freshvisionacademy.org/",
      };

  return (
    <section className="py-20 md:py-28 bg-[#0D1B2A] text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-[0.7rem] md:text-[0.75rem] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-4">
            {content.eyebrow}
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-5 leading-tight">
            {content.heading}
          </h2>
          <p className="text-white/75 text-base md:text-lg mb-10 leading-relaxed">
            {content.body}
          </p>
          <a
            href={content.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#C5A059] hover:bg-[#D4AF6A] text-[#0D1B2A] font-semibold px-7 py-3.5 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
          >
            {content.cta}
            <ExternalLink className="w-4 h-4" strokeWidth={2} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default AcademyClasses;
